module.exports = __webpack_public_path__ + "img/background_orange.372b0706.png";